import { GetResellersResult, SendWishListToDealerResult, SendWishListResult, GetResellersResultCode } from '../models';

export const TestSendWishListToDealerResult: SendWishListToDealerResult = {
    result: true
};

export const TestSendWishListResult: SendWishListResult = {
    result: true
};

export const TestResellersResult: GetResellersResult = {
    'customers': [
        {
            'address': 'VIA SEMPIONE 2B, PERO 20016, MI',
            'fax': '02\/3536845',
            'isWebSeller': false,
            'lat': 45.5152299,
            'lng': 9.0781513,
            'mail': 'giuseppe.allegri@tiscali.it',
            'name': 'ALLEGRI DI ALLEGRI GIUSEPPE E MARCO SNC',
            'telephone': '02\/3539067', 'webSite': null,
            isOpen: false
        },
        {
            'address': 'VIA F. FILZI 14, BARANZATE 20021, MI',
            'fax': '02\/89285200',
            'isWebSeller': false,
            'lat': 45.525132,
            'lng': 9.115858,
            'mail': 'vendite@tarenzi.it',
            'name': 'TARENZI S.P.A.',
            'telephone': '02\/892852',
            'webSite': 'www.tarenzi.com',
            isOpen: false
        },
        {
            'address': 'VIA FRANCESCO OLGIATI 34, MILANO 20143, MI',
            'fax': '02\/8135456',
            'isWebSeller': true,
            'lat': 45.4391344,
            'lng': 9.1466661,
            'mail': 'amministrazione@milutensili.it',
            'name': 'MIL UTENSILI SRL',
            'telephone': '02\/8136047',
            'webSite': 'www.milutensili.it',
            isOpen: false
        },
        {
            'address': 'V.DELLA RESISTENZA 129\/A, BUCCINASCO 20090, MI',
            'fax': '02\/45700010',
            'isWebSeller': false,
            'lat': 45.4139898,
            'lng': 9.1167264,
            'mail': 'direzione@lanuovalimfer.it',
            'name': 'LA NUOVA LIMFER SRL',
            'telephone': '02\/45700088',
            'webSite': 'www.lanuovalimfer.it',
            isOpen: false
        },
        {
            'address': 'VIA PIEMONTE 23, SENAGO 20030, MI',
            'fax': '02\/99010281',
            'isWebSeller': false,
            'lat': 45.575355,
            'lng': 9.130894,
            'mail': 'federicacosta@costa-it.com',
            'name': 'COSTA FERRUTENSIL S.R.L.',
            'telephone': '02\/9986029',
            'webSite': 'www.costa-it.com',
            isOpen: false
        }
    ],
    'position': {
        'address': 'Via Giorgio de Chirico, 3, 20151 Milano MI, Italia',
        'lat': 45.494616,
        'lng': 9.0986795999999988
    },
    'result': GetResellersResultCode.RequestLimitReached
};



// WEBPACK FOOTER //
// ./src/app/services/mock-backend.ts